/**
 * Test IDs for QA automation.
 */
export const testIds = {
  loadBoardLoadsListPoweredByExtension: "load-board-loads-list-powered-by-extension",
  loadBoardLoadsListOriginRadius: "load-board-loads-list-origin-radius",
  loadBoardLoadsListDestinationRadius: "load-board-loads-list-destination-radius",
} as const;
